import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=f3d3c8ac&scoped=true&"
import script from "./Pc.vue?vue&type=script&lang=js&"
export * from "./Pc.vue?vue&type=script&lang=js&"
import style0 from "./Pc.vue?vue&type=style&index=0&id=f3d3c8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d3c8ac",
  null
  
)

export default component.exports